export default __webpack_public_path__ + "static/media/tempestofsetbg.40534cdf.jpg";